import { useEffect, useCallback } from 'react';
import { useDynamicContext, useIsLoggedIn } from "@dynamic-labs/sdk-react-core";
import { isEthereumWallet } from '@dynamic-labs/ethereum';

export const useOverrideBuyButton = () => {
  const { primaryWallet } = useDynamicContext();
  const isLoggedIn = useIsLoggedIn();

  const handleClick = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!isLoggedIn || !primaryWallet || !isEthereumWallet(primaryWallet)) {
      console.log('Wallet not ready');
      return;
    }

    // Get wallet address and networks
    const address = primaryWallet.address;
    const networks = primaryWallet.connector.evmNetworks.map(network => 
      network.name.toLowerCase()
    );

    // Create URL parameters
    const params = new URLSearchParams({
      addresses: JSON.stringify({ [address]: networks }),
      appId: '12109858-450c-4be4-86b9-13867f0015a1',
      // assets: JSON.stringify(['ETH', 'USDC']),
      defaultExperience: 'buy',
      defaultPaymentMethod: 'APPLE_PAY'
    });

    // Open Coinbase Pay URL
    const url = `https://pay.coinbase.com/buy/select-asset?${params.toString()}`;
    console.log('Opening URL:', url);
    window.open(url, '_blank');
  }, [isLoggedIn, primaryWallet]);

  useEffect(() => {
    const findButton = (root) => {
      const shadows = root.querySelectorAll('*');
      for (const element of shadows) {
        if (element.shadowRoot) {
          const button = element.shadowRoot.querySelector('[data-testid="buy-crypto-button"]');
          if (button) return button;
          const deepButton = findButton(element.shadowRoot);
          if (deepButton) return deepButton;
        }
      }
      return null;
    };

    const setupButton = () => {
      const button = findButton(document);
      if (!button) return false;

      // Enable the button if we have a wallet
      if (isLoggedIn && primaryWallet && isEthereumWallet(primaryWallet)) {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
      } else {
        button.classList.add('disabled');
        button.setAttribute('disabled', 'disabled');
      }

      // Clone and replace to remove old listeners
      const newButton = button.cloneNode(true);
      button.parentNode?.replaceChild(newButton, button);

      // Add our click handler
      newButton.addEventListener('click', handleClick);
      
      return true;
    };

    // Poll for button every 500ms until found or timeout
    const startTime = Date.now();
    const interval = setInterval(() => {
      if (setupButton() || Date.now() - startTime > 30000) {
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [isLoggedIn, primaryWallet, handleClick]);
}; 